/* unplugin-vue-components disabled */import { render } from "./calendar.vue?vue&type=template&id=44395724&scoped=true"
import script from "./calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar.vue?vue&type=script&setup=true&lang=js"

import "./calendar.vue?vue&type=style&index=0&id=44395724&lang=stylus"
import "./calendar.vue?vue&type=style&index=1&id=44395724&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44395724"],['__file',"src/controls/calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44395724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44395724', __exports__)) {
    api.reload('44395724', __exports__)
  }
  
  module.hot.accept("./calendar.vue?vue&type=template&id=44395724&scoped=true", () => {
    api.rerender('44395724', render)
  })

}


export default __exports__